<!--
 Copyright 2021 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<template>
  <v-app>
    <v-app-bar
      rounded
    >
      <v-app-bar-title> OTA Analyzer </v-app-bar-title>
      <v-spacer />
      <v-btn
        v-for="link in links"
        :key="`${link}-header-link`"
        :to="{ name: link }"
        class="ml-5"
      >
        {{ link }}
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      links: ['Analysis', 'Demo', 'About'],
    }
  },
}
</script>

<style>
h3 {
  text-align: center;
}
</style>